// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationDetails-module__container--UD68V","content":"NotificationDetails-module__content--ofrv0"};